import { ActionTree } from 'vuex';

import store from './filter-wrapper-types.store';
import { IFilterWrapperState } from "./filter-wrapper-states.store";

export const actions: ActionTree<IFilterWrapperState, any> = {
    [store.Set.PROPERTY_SEARCH_PARAM]({ commit }, payload): void {
        commit(store.Set.PROPERTY_SEARCH_PARAM, payload);
    },
    [store.Set.PERSON_SEARCH_PARAM]({ commit }, payload): void {
        commit(store.Set.PERSON_SEARCH_PARAM, payload);
    },
    [store.Set.DEMAND_SEARCH_PARAM]({ commit }, payload): void {
        commit(store.Set.DEMAND_SEARCH_PARAM, payload);
    },
    [store.Set.TASK_SEARCH_PARAM]({ commit }, payload): void {
        commit(store.Set.TASK_SEARCH_PARAM, payload);
    },
}